import { format, subDays } from 'date-fns';
import { useEffect } from 'react';

import { config } from '@/config';
import { alertDialog, confirmDialog } from '@/services/DialogService';

/**
 * Preview hosts expire after two days. Runs after React mounts so the confirm
 * and caution use auditor dialogs instead of window.confirm/alert.
 */
export const PreviewBuildAgeGate = () => {
  useEffect(() => {
    if (!config.IS_PREVIEW) {
      return;
    }

    // Match VITE_BUILD_DATE from `date +%y%m%d%H%M` (24-hour); `hh` is 01-12 and breaks the compare.
    const twoDaysOld = format(subDays(new Date(), 2), 'yyMMddHHmm');
    const buildIsValid = twoDaysOld < config.BUILD_DATE;
    console.log('Preview build date:', config.BUILD_DATE, 'two days old:', twoDaysOld);
    if (buildIsValid) {
      return;
    }

    void (async () => {
      const stay = await confirmDialog(
        'This preview build has expired, and may not work correctly.\n' + 'Are you sure you want to continue using it?',
        { title: 'Expired preview build', confirmLabel: 'Continue', tone: 'danger' },
      );
      if (stay) {
        await alertDialog('You are using an expired preview build. Please proceed with caution.', {
          title: 'Expired preview',
        });
        return;
      }
      window.location.href = window.location.toString().replace('preview-', '');
    })();
  }, []);

  return null;
};
